(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sekund-concept-home"] && !Shopify.designMode) return;
  try {
    
  const initSekundRotator = (root) => {
    if (root.dataset.rotatorReady === 'true') return
    root.dataset.rotatorReady = 'true'
    const slides = [...root.querySelectorAll('[data-sekund-slide]')]
    const dots = [...root.querySelectorAll('[data-sekund-dot]')]
    const pause = root.querySelector('[data-sekund-pause]')
    if (slides.length < 2 || !pause) return
    const delay = Number(root.dataset.interval || 4) * 1000
    let current = 0
    let timer
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const show = (next) => {
      current = (next + slides.length) % slides.length
      slides.forEach((slide, index) => {
        const active = index === current
        slide.classList.toggle('is-active', active)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true')
        const link = slide.querySelector('a')
        if (link) link.tabIndex = active ? 0 : -1
      })
      dots.forEach((dot, index) => {
        const active = index === current
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
    }
    const stop = () => window.clearInterval(timer)
    const start = () => {
      stop()
      if (!paused) timer = window.setInterval(() => show(current + 1), delay)
    }
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      show(index)
      start()
    }))
    pause.addEventListener('click', () => {
      paused = !paused
      pause.classList.toggle('is-paused', paused)
      pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel)
      start()
    })
    root.addEventListener('mouseenter', stop)
    root.addEventListener('mouseleave', start)
    root.addEventListener('focusin', stop)
    root.addEventListener('focusout', start)
    pause.classList.toggle('is-paused', paused)
    pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel)
    start()
  }
  const initSekundRotators = (scope) => scope.querySelectorAll('[data-sekund-rotator]').forEach(initSekundRotator)
  initSekundRotators(document)
  document.addEventListener('shopify:section:load', (event) => initSekundRotators(event.target))

  } catch(e) { console.error(e); }
})();
})();
